var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.editable === false
    ? _c("el-table-column", {
        attrs: {
          label: _vm.label,
          width: _vm.width,
          prop: _vm.prop,
          sortable: _vm.sortable
        }
      })
    : _c("el-table-column", {
        attrs: {
          label: _vm.label,
          width: _vm.width,
          prop: _vm.prop,
          sortable: _vm.sortable
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop:
                        _vm.tableDataName + "." + scope.$index + "." + _vm.prop,
                      rules: _vm.rules
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "text",
                        clearable: true,
                        maxlength: _vm.maxlength,
                        resize: "none",
                        placeholder: _vm.placeholder,
                        disabled:
                          _vm.disabled === true
                            ? _vm.disabled
                            : _vm.addRowMode === false
                            ? _vm.disabled
                            : !_vm.changeable(
                                _vm.addRowMode,
                                _vm.changeCase,
                                _vm.tableDataCount,
                                scope.$index
                              ),
                        autofocus: _vm.autofocus,
                        validator: _vm.validator,
                        uppercase: _vm.uppercase
                      },
                      on: { input: _vm.setter },
                      model: {
                        value: scope.row[_vm.prop],
                        callback: function($$v) {
                          _vm.$set(scope.row, _vm.prop, $$v)
                        },
                        expression: "scope.row[prop]"
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }